export default __webpack_public_path__ + "static/media/videoLecture.f0728970.svg";